export default "__VITE_ASSET__Bs0$5EBm__"